<template>
	<div :class="$style['app-root']">
		<RouterView />
		<div
			v-if="isValidating"
			:class="$style['loading-spinner']"
		>
			<Spinner />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Spinner from '@c:essentials/Spinner'
export default {
	name: 'App',
	metaInfo: {
		titleTemplate (titleChunk) {
			return titleChunk ? `${titleChunk} | Recar` : 'Recar'
		}
	},
	components: {
		Spinner
	},
	computed: {
		...mapGetters({
			isValidating: 'Auth/isValidating'
		})
	}
}
</script>

<style lang="scss" module>
.app-root {
		min-height: 100vh;
		min-height: 100dvh;
	}

.loading-spinner {
		position: fixed;
		inset: 0;
		z-index: 10001;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgb(255, 255, 255, 0.7);
	}
</style>
